import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import queryString from "query-string";
import { setRef } from "../helpers/utils";

// Layout
import Layout from "../components/layout";

// Components
import BG from "../components/bg";
import Hero from "../components/hero";
import Line from "../components/line";
import QuickpageHero from "../components/quickpage-hero";
import Works from "../components/works";
import Testimonials from "../components/testimonials";
import Facebook from "../components/facebook-group";
import Faq from "../components/faq";
import Pricing from "../components/pricing";

import Seo from "../components/seo";

export default class Index extends Component {
  componentDidMount() {
    const qs = queryString.parse(window.location.search).s;

    if (qs) {
      toast.success(
        "Thank you for your request! Please check your email and or text!😎"
      );
      window.history.replaceState(null, null, "/");
    }
    setRef(this.props.location);
  }

  render() {
    return (
      <Layout location={this.props.location}>
        <Seo
          title="Quickpage :: The Video Follow Up App for Sales Professionals"
          description="Quickpage is a video follow-up tool for sales that's increasing engagement by 200%. Video email and texting is the future of sales."
          keywords="video, email, video email, email video, sales app"
          url="https://kwrur.quickpage.io"
        />
        <BG>
          <Hero
            headline="Capture, convert and close more clients with Quickpage"
            description="Quickpage is the easiest, most effective video email closing tool available. Stand out from other agents in your neighborhood by personally introducing yourself and your services in the most genuine way."
            location={this.props.location}
          />
          <QuickpageHero />
        </BG>

        <Works />
        <Testimonials
          title="Quickpage Customer Stories"
          description="Learn how users around the globe use Quickpage to build stronger relationships with their clients and improve the way they do business. Take a minute and read the genuine and heartfelt stories we receive daily. "
        />
        <Facebook />
        <Line contain />
        <Faq />
        <Pricing {...this.props} />
        <Line />
        <ToastContainer />
      </Layout>
    );
  }
}
